// @ts-nocheck
import { BANNERS_ORDER_DRAWER_CHANGED, BANNERS_PROMOTION_SEARCH_MODAL_CHANGED } from '../../types';

const initialState = {
    bannersOrderDrawer: {
        isVisible: false,
        bannersList: [],
    },
    promotionSearchModal: {
        isVisible: false,
        form: null,
    },
};

const banners = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case BANNERS_ORDER_DRAWER_CHANGED: {
            return {
                ...state,
                bannersOrderDrawer: {
                    ...state.bannersOrderDrawer,
                    ...payload,
                },
            };
        }
        case BANNERS_PROMOTION_SEARCH_MODAL_CHANGED: {
            return {
                ...state,
                promotionSearchModal: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default banners;
